import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import momentPropTypes from 'react-moment-proptypes';
import FormattedListValue from '@/shared/components/FormattedListValue';
import messages from './invoiceScheduleMessages';
import FormattedDayMonth from '../../../shared/components/FormattedDayMonth';
import dateFormatService from '@/shared/services/DateFormatService';
import moment from 'moment';

const getInvoiceText = (id, invoiceTexts, lang) => {
  if (!id || !invoiceTexts) return null;
  const text = invoiceTexts.find(t => t.id === id);
  if (!text) return null;
  return (
    <div>
      <FormattedListValue list="invoicetext" id={text.id} fallback={text.name} />
      <span>{text.languages[lang]}</span>
    </div>
  );
};

const InvoiceScheduleLinesTable = ({ lines, schedule, invoiceTexts, taskTemplates }) => {
  const invType = schedule.invoicingType;
  const showDateColumns = lines && lines.some(x => !x.mainTaskTemplateId);
  const showTaskColumns = lines && lines.some(x => !!x.mainTaskTemplateId);
  const showReferenceYear = schedule.useReferenceYear;

  return (
    <div className="subtable-wrapper width100pct">
      {lines && (
        <table className="table subtable">
          <thead>
            <tr>
              {showDateColumns && (
                <th>
                  <FormattedMessage {...messages.RegistrationsUntil} />
                </th>
              )}
              {showDateColumns && (
                <th>
                  <FormattedMessage {...messages.InvoiceCreationDate} />
                </th>
              )}
              {showTaskColumns && (
                <th>
                  <FormattedMessage {...messages.MainTask} />
                </th>
              )}
              {showTaskColumns && (
                <th>
                  <FormattedMessage {...messages.Subtask} />
                </th>
              )}
              {invType === 2 && (
                <th>
                  <FormattedMessage {...messages.AdvanceOrSettlement} />
                </th>
              )}
              <th>
                <FormattedMessage {...messages.InvoiceText} />
              </th>
              {showReferenceYear && (
                <th>
                  <FormattedMessage {...messages.ReferenceYear} />
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {lines.map(line => {
              const invoiceTextId =
                line.invoiceTextId ??
                (schedule.invoicingType === 2 && !line.fixed
                  ? schedule.settlmentInvoiceTextId
                  : schedule.invoiceTextId);

              const taskTemplate =
                line.mainTaskTemplateId && taskTemplates
                  ? taskTemplates.find(x => x.id === line.mainTaskTemplateId)
                  : null;
              const subTaskTemplate =
                taskTemplate?.children && line.subtaskTemplateId
                  ? taskTemplate.children.find(x => x.id === line.subtaskTemplateId)
                  : null;

              return (
                <tr key={line.id}>
                  {showDateColumns && (
                    <td>
                      {!line.mainTaskTemplateId && (
                        <label>
                          <FormattedDayMonth value={line.registrationsUntil} />
                        </label>
                      )}
                    </td>
                  )}

                  {showDateColumns && (
                    <td>
                      {!line.mainTaskTemplateId && (
                        <label>
                          <FormattedDayMonth value={line.invoiceCreationDate} />
                        </label>
                      )}
                    </td>
                  )}
                  {showTaskColumns && (
                    <td>
                      {!!line.mainTaskTemplateId && (
                        <label className="overflow-ellipsis">
                          <FormattedListValue
                            list="TaskTemplate"
                            id={line.mainTaskTemplateId}
                            fallback={taskTemplate?.name}
                          />
                        </label>
                      )}
                    </td>
                  )}

                  {showTaskColumns && (
                    <td>
                      {!!line.mainTaskTemplateId && !!line.subtaskTemplateId && (
                        <label className="overflow-ellipsis">
                          <FormattedListValue
                            list="TaskTemplate"
                            id={line.subtaskTemplateId}
                            fallback={subTaskTemplate?.name}
                          />
                        </label>
                      )}
                    </td>
                  )}
                  {invType === 2 && (
                    <td>
                      <label>
                        {line.fixed ? (
                          <FormattedMessage {...messages.Advance} />
                        ) : (
                          <FormattedMessage {...messages.Settlement} />
                        )}
                      </label>
                    </td>
                  )}

                  <td>
                    <label>{getInvoiceText(invoiceTextId, invoiceTexts)}</label>
                  </td>
                  {showReferenceYear && (
                    <td>
                      {line.mainTaskTemplateId ? (
                        <FormattedMessage {...messages.UseReferenceYearOfTask} />
                      ) : (
                        <FormattedMessage
                          {...messages.FiscalYearCustomerOn}
                          values={{
                            date: dateFormatService.formatDayMonth(
                              moment
                                .utc(line.registrationsUntil)
                                .add(line.referenceYearDeviation ?? 0, 'days'),
                            ),
                          }}
                        />
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

InvoiceScheduleLinesTable.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      invoiceCreationDate: momentPropTypes.momentObj,
      registrationsUntil: momentPropTypes.momentObj,
    }),
  ).isRequired,
  schedule: PropTypes.shape({
    invoicingType: PropTypes.number,
    invoiceTextId: PropTypes.string,
    settlmentInvoiceTextId: PropTypes.string,
  }).isRequired,
  invoiceTexts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default InvoiceScheduleLinesTable;
